<div class="notification-box">
  <xvi-notification-item *ngFor="let notification of notifications$ | async" [notification]="notification">
  </xvi-notification-item>
</div>
